import type { FluxErrorEntityErrorCodes } from '../../types.js';

export const AutomationV2ExecutionActionCreateCardDeadlineCodes = {
  AutomationV2ExecutionActionCreateCardDeadlineFailedToCreateDeadline: {
    code: 'automation-v2-execution-action/create-card-deadline-failed-to-create-deadline',
    explanation: `Erro ao tentar criar o prazo.

**Causas comuns:**
- O card já possui um prazo definido para este escopo (etapa ou geral).
- O modelo de prazo não existe.

**Como resolver:**
Verifique se o card já possui o prazo que você está tentando criar.`,
    localizations: {},
    message: 'Não foi possível criar o prazo para o card.',
  },
  AutomationV2ExecutionActionCreateCardDeadlineMissingCardId: {
    code: 'automation-v2-execution-action/create-card-deadline-missing-card-id',
    explanation: `ID do card não fornecido.
    
**Causas comuns:**
- A variável \`context.card.id\` não foi resolvida.

**Como resolver:**
Certifique-se de que a automação tem um card no contexto ou forneça um ID manualmente.`,
    localizations: {},
    message: 'O ID do card é obrigatório para criar um prazo.',
  },
  AutomationV2ExecutionActionCreateCardDeadlineMissingDeadlineId: {
    code: 'automation-v2-execution-action/create-card-deadline-missing-deadline-id',
    explanation: `ID do modelo de prazo não fornecido.

**Como resolver:**
Selecione um modelo de prazo na configuração da ação.`,
    localizations: {},
    message: 'O ID do modelo de prazo é obrigatório.',
  },
} as const satisfies FluxErrorEntityErrorCodes<'automation-v2-execution-action'>;
